/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Native_DescInputs */

const en_mk_team_native_desc = /** @type {(inputs: Mk_Team_Native_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect your computer and sign in through official Claude Code or Codex. Coding runs on your computer with that agent account.`)
};

const id_mk_team_native_desc = /** @type {(inputs: Mk_Team_Native_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan komputer, lalu login melalui Claude Code atau Codex resmi. Coding berjalan di komputermu memakai akun agent tersebut.`)
};

/**
* | output |
* | --- |
* | "Connect your computer and sign in through official Claude Code or Codex. Coding runs on your computer with that agent account." |
*
* @param {Mk_Team_Native_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_native_desc = /** @type {((inputs?: Mk_Team_Native_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Native_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_native_desc(inputs)
	return en_mk_team_native_desc(inputs)
});